import React from 'react';
import { kitContents } from '../../data/productContent';
import { productImages } from '../../data/siteConfig';
export function KitSection() {
  return <section aria-labelledby="kit-title" className="bg-canvas-deep" data-id="element-212" data-mp="2wzhxatmvp91z">
      <div className="mx-auto grid max-w-page items-center gap-12 px-5 py-20 md:px-10 lg:grid-cols-[1fr_1fr] lg:gap-20 lg:py-24" data-id="element-213" data-mp="2j7bdmxkiojxs">
        <div className="flex justify-center rounded-md bg-surface p-6 md:p-10" data-id="element-214" data-mp="2n5itzrb2jj8g">
          {/* White Box.jpg is ~368px wide — shown at native size, never enlarged. */}
          <img src={productImages.kit.src} alt={productImages.kit.alt} width={368} className="block h-auto w-full max-w-[368px]" data-id="element-215" data-mp="3fuzjag3e6k0g" />
        </div>
        <div className="max-w-md" data-id="element-216" data-mp="36u1fnywv8eie">
          <h2 id="kit-title" className="font-display text-4xl font-medium leading-tight text-ink md:text-[52px]" data-id="element-217" data-mp="36xfgh2pvsfnq">
            What’s in the box.
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-ink-muted" data-id="element-218" data-mp="1vh7gn91u3ifr">
            The mask and accessories, together in one box.
          </p>
          <ul className="mt-8 border-t border-line-strong" data-id="element-219" data-mp="15xk4thzu6c6t">
            {kitContents.map(item => <li key={item} className="border-b border-line-strong py-4 text-[16px] text-ink" data-id="element-220" data-mp="1kujinnla719q">
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}